// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"9f74252a","228":"d77ed1f1","568":"2b523181","600":"22281d67","640":"9b2d3328","672":"ddd7cc7c","916":"de5fb6cd","960":"01f6a6e7","976":"715936a4"}[chunkId] + ".chunk.js";
};